var interval = null;

document.addEventListener("turbo:load", () => {
    countdown(120);

    const input = document.querySelector('.email-confirmation-input');
    if (input) {
      input.addEventListener('keypress', function (e) {    
          var charCode = (e.which) ? e.which : e.keyCode;

          if (input.value.length >= 6) {
              e.preventDefault();
              return false;
          }

          if (String.fromCharCode(charCode).match(/[^0-9]/g)) {
              e.preventDefault();
              return false;
          }
      });
    }

    const genNew = document.querySelector('.generate-new');
    if (genNew) {
      genNew.addEventListener('click', function() {
          countdown(120);
      });
    }
});

function countdown(count) {
    document.querySelectorAll('.generate-new-container').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.wait-container').forEach(el => el.style.display = 'block');
    
    if (!interval) {
        interval = setInterval(function() {
            if (count == 0) {
                document.querySelectorAll('.generate-new-container').forEach(el => el.style.display = 'block');
                document.querySelectorAll('.wait-container').forEach(el => el.style.display = 'none');
                clearInterval(interval);
                interval = null;
                return;
            }

            document.querySelectorAll(".wait-container .counter").forEach(el => el.innerHTML = count);
            count -= 1;
        }, 1000);
    }
}
